export default "__VITE_ASSET__C7wkV6Pb__"